/* Seasonal return copy only. Paris clock; original DOM is retained for expiry. */
(function () {
  'use strict';
  function parisDay(now) {
    var parts = new Intl.DateTimeFormat('en-CA', {timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(now);
    function part(type) { return parts.find(function (p) { return p.type === type; }).value; }
    return part('year') + '-' + part('month') + '-' + part('day');
  }
  function active(now, end) {
    var day = parisDay(now);
    return /^\d{4}-\d{2}-\d{2}$/.test(end) && day >= '2026-11-01' && day <= end;
  }
  if (typeof module !== 'undefined') module.exports = {parisDay: parisDay, active: active};
  if (typeof document === 'undefined' || window.LPCReturns) return;
  var config = document.getElementById('lpc-returns-config');
  if (!config) return;
  config = JSON.parse(config.textContent);
  var observer, timer;
  function seasonal(text) {
    for (var i = 0; i < config.pairs.length; i++) {
      var p = config.pairs[i];
      if (text.includes(p[0])) return text.split(p[0]).join(p[1]);
    }
    return text;
  }
  function mark(element, original, next) {
    element.dataset.standard = original;
    element.dataset.seasonal = next;
  }
  function refresh() {
    if (observer) observer.disconnect();
    var enabled;
    try { enabled = active(new Date(), config.end); } catch (e) { enabled = null; }
    // Liquid remains authoritative when Intl is unavailable.
    if (enabled !== null) {
      document.querySelectorAll('[data-lpc-returns-card]').forEach(function (e) { e.hidden = !enabled; });
      document.querySelectorAll('lpc-returns').forEach(function (e) {
        var html = enabled ? e.dataset.seasonal : e.dataset.standard;
        if (e.innerHTML !== html) e.innerHTML = html;
        if (!enabled) e.replaceWith.apply(e, Array.from(e.childNodes));
      });
      // Reassurance injected by theme scripts or Shopify section refreshes uses the same copy.
      if (enabled) {
        var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT), nodes = [], node;
        while ((node = walker.nextNode())) {
          if (!node.parentElement || node.parentElement.closest('lpc-returns,del,s,script,style,textarea,select,svg,[data-policy-content],#sm-refund-policy,template')) continue;
          if (/30/.test(node.nodeValue)) nodes.push(node);
        }
        nodes.forEach(function (text) {
          if (!text.isConnected) return;
          // Match complete rich-text phrases before their emphasis splits the words.
          var parent = text.parentElement;
          if (/^(STRONG|B)$/.test(parent.tagName) && parent.parentElement) {
            var container = parent.parentElement, rich = container.innerHTML, richNext = seasonal(rich);
            if (richNext !== rich) {
              var richElement = document.createElement('lpc-returns'); richElement.style.display = 'contents';
              mark(richElement, rich, richNext); richElement.innerHTML = richNext;
              container.replaceChildren(richElement); return;
            }
          }
          // Store escaped text as HTML so expiry also preserves literal characters.
          var holder = document.createElement('span'); holder.textContent = text.nodeValue;
          var original = holder.innerHTML, next = seasonal(original);
          if (original === next) return;
          var e = document.createElement('lpc-returns'); e.style.display = 'contents';
          mark(e, original, next); e.innerHTML = enabled ? next : original; text.replaceWith(e);
        });
      }
    }
    if (observer) observer.observe(document.body, {childList: true, subtree: true, characterData: true});
    clearTimeout(timer);
    // Recheck through Paris midnight, visibility changes and restored browser history.
    timer = setTimeout(refresh, 60000);
  }
  function boot() {
    observer = new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(refresh, 0); });
    refresh();
    document.addEventListener('visibilitychange', refresh);
    document.addEventListener('shopify:section:load', refresh);
    window.addEventListener('pageshow', refresh);
  }
  window.LPCReturns = {refresh: refresh, active: active, parisDay: parisDay};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true}); else boot();
})();
